import * as Yup from "yup";
import { createPersologElementQuestionClassFormSchema } from "../persolog-element-question-class-form/persolog-element-question-class-form.consts";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createPersologElementQuestionFormSchema = (t: TFunc) =>
	Yup.object({
		title: Yup.string().required(t("validation:questionFieldRequired")),
		questionClasses: Yup.array()
			.of(createPersologElementQuestionClassFormSchema(t))
			.min(4)
			.required(t("validation:classesRequired")),
	});
